/**
 * PayAppEditorScreen — full-page pay app editor inside V3Shell (top nav visible).
 */
import { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useQueryClient } from '@tanstack/react-query'
import PayAppEditorModal from './modal/PayAppEditorModal'

export default function PayAppEditorScreen() {
  const { projectId, payAppId } = useParams<{ projectId: string; payAppId: string }>()
  const navigate = useNavigate()
  const qc = useQueryClient()

  const pid = Number(projectId)
  const paid = payAppId === 'new' ? null : Number(payAppId)
  const invalid = !Number.isFinite(pid) || (payAppId !== 'new' && !Number.isFinite(paid!))

  useEffect(() => {
    if (invalid) navigate('/projects', { replace: true })
  }, [invalid, navigate])

  if (invalid) return null

  return (
    <>
      <div className="topbar">
        <div className="crumb">
          Projects · <b>Pay application</b>
        </div>
      </div>
      <div className="pc" style={{ overflowX: 'auto', padding: '0 0 0 0', width: '100%', boxSizing: 'border-box' }}>
        <div style={{ width: '100%', maxWidth: '100%' }}>
        <PayAppEditorModal
          embedded
          projectId={pid}
          payAppId={paid}
          isOpen
          onClose={() => navigate(`/projects?pm=${pid}`, { replace: true })}
          onSaved={() => {
            qc.invalidateQueries({ queryKey: ['project-payapps', pid] })
          }}
        />
        </div>
      </div>
    </>
  )
}
